export default __webpack_public_path__ + "static/media/05-460x460.be6438ad.jpeg";